export class InfiniteScollingText {
  constructor() {
    this._elements = document.querySelectorAll("[infinite-scrolling-text]");
    this._textScroll = document.querySelectorAll(".text-scroll");
    this.init();
  }

  init() {
    if (!this._elements) return;

    this._elements.forEach((element) => {
      const words = JSON.parse(element.getAttribute("infinite-scrolling-text"));

      words.forEach((word) => {
        this.addItemToScrolling(word);
      });
    });
  }

  addItemToScrolling = (word) => {
    this._textScroll.forEach((scroll) => {
      const textItem = document.createElement("span");
      textItem.classList.add("text-item");
      textItem.innerHTML = word.text;
      scroll.appendChild(textItem);
      scroll.appendChild(this.getSeparator());
    });
  };

  getSeparator = () => {
    const separator = document.createElement("span");
    separator.classList.add("separator");
    separator.innerHTML = "-";
    return separator;
  };
}
